import { GRID_TOGGLE_PARAMS, readStoredToggles, TOGGLE_ABSENT, writeStoredToggle } from "@src/utils/gridPreferences.utils";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const useGridTogglePersistence = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const hasRestored = useRef(false);
	const hasSkippedFirstWrite = useRef(false);

	useEffect(() => {
		if (hasRestored.current) return;
		hasRestored.current = true;

		const stored = readStoredToggles();
		const next = new URLSearchParams(searchParams);
		let changed = false;

		GRID_TOGGLE_PARAMS.forEach((key) => {
			if (next.has(key) || stored[key] === undefined || stored[key] === TOGGLE_ABSENT) return;
			next.set(key, stored[key]);
			changed = true;
		});

		if (changed) setSearchParams(next, { replace: true });
	}, [searchParams, setSearchParams]);

	useEffect(() => {
		if (!hasRestored.current) return;
		if (!hasSkippedFirstWrite.current) {
			hasSkippedFirstWrite.current = true;
			return;
		}

		GRID_TOGGLE_PARAMS.forEach((key) => {
			writeStoredToggle(key, searchParams.get(key) ?? TOGGLE_ABSENT);
		});
	}, [searchParams]);
};
